<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-md-2">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="datatable.queries.per_page"
                      class="ml-1 mr-1"
                      size="sm"
                      :options="[10, 15, 25, 50, 100]"
                      @change="getAgencies"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <SearchInput
                  v-model="datatable.queries.search"
                  @search="getAgencies"
                />
              </div>
            </div>
            <template v-if="!loadingAgencies">
              <div class="table-responsive mb-0">
                <b-table
                  :items="agencies"
                  :fields="datatable.columns"
                  :sort-by="datatable.queries.sort_by"
                  :sort-desc="datatable.queries.sort_desc"
                  :no-local-sorting="true"
                  @sort-changed="sortChanged"
                >
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                  <template v-slot:cell(is_template)="data">
                    <feather
                      v-if="!!data.item.is_template"
                      type="check"
                      class="icon-dual-success"
                    />
                  </template>
                  <template v-slot:cell(free_fee)="data">
                    <feather
                      v-if="!!data.item.free_fee"
                      type="check"
                      class="icon-dual-success"
                    />
                  </template>
                  <template v-slot:cell(last_login)="data">
                    {{ data.item.last_login | moment('MM-DD-YYYY hh:mm A') }}
                  </template>
                  <template v-slot:cell(actions)="data">
                    <b-button
                      variant="primary"
                      size="sm"
                      title="Sign In"
                      :disabled="loadingImpersonate"
                      @click="impersonate(data.item.owner.id)"
                    >
                      <b-spinner v-if="loadingImpersonate" small />
                      <i v-else class="uil uil-sign-out-alt"></i>
                    </b-button>
                    <router-link
                      :to="{
                        name: 'admin.agencies.edit',
                        params: { id: data.item.id },
                      }"
                      class="btn btn-success btn-sm ml-1"
                    >
                      <i class="uil uil-edit"></i>
                    </router-link>
                    <b-button
                      variant="danger"
                      size="sm"
                      title="Delete"
                      class="ml-1"
                      :disabled="loadingRemove === data.item.id"
                      @click="archive(data.item)"
                    >
                      <b-spinner v-if="loadingRemove === data.item.id" small />
                      <i v-else class="uil uil-trash"></i>
                    </b-button>
                  </template>
                </b-table>
              </div>
              <div class="row mt-4">
                <div class="col">
                  <div class="float-left mt-2">
                    Total {{ totalAgencies }} agencies
                  </div>
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="datatable.queries.page"
                        :total-rows="totalAgencies"
                        :per-page="datatable.queries.per_page"
                        @change="onPageChanged"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="text-center">
              <b-spinner></b-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="showDeleteModal" title="Delete Agency">
      <p v-if="selectedAgency"
        >Are you sure you want to delete agency <b>"{{ selectedAgency.name }}"</b>? <br/> The agency will be archived for 15 days and then permanently deleted.</p
      >
      <template v-slot:modal-footer>
        <b-button variant="light" @click="showDeleteModal = false"
          >Cancel</b-button
        >
        <b-button variant="danger" @click="handleArchive">Delete</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import SearchInput from '@components/Common/SearchInput.vue'

export default {
  components: {
    SearchInput
  },
  data() {
    return {
      datatable: {
        columns: [
          { key: 'id', label: '#', sortable: true },
          { key: 'name', sortable: true },
          { key: 'owner.email', label: 'Email', sortable: true },
          { key: 'is_template', sortable: true },
          { key: 'free_fee', sortable: true },
          { key: 'subscription', sortable: true },
          { key: 'last_login', label: 'Last Login', sortable: true },
          { key: 'actions' },
        ],
        queries: {
          per_page: 10,
          page: 1,
          status: 'active',
          search: null,
          sort_by: 'id',
          sort_desc: false,
        },
      },
      showDeleteModal: false,
      selectedAgency: null,
      loadingAgencies: false,
      loadingImpersonate: false,
      loadingRemove: null,
    }
  },

  computed: {
    agencies() {
      return this.$store.getters['agency/all'] || []
    },

    totalAgencies() {
      return this.$store.getters['agency/total']
    },
  },

  created() {
    this.$store.dispatch('agency/setCurrentPage', 'index')
  },

  mounted() {
    if (this.$store.getters['agency/all'] === null) {
      this.getAgencies()
    } else {
      this.datatable.queries = this.$store.getters['agency/queries']
    }
  },

  methods: {
    sortChanged(args) {
      this.datatable.queries.sort_by = args.sortBy
      this.datatable.queries.sort_desc = args.sortDesc
      this.datatable.queries.page = 1
      this.getAgencies()
    },

    onPageChanged(page) {
      this.datatable.queries.page = page
      this.getAgencies()
    },

    getAgencies() {
      this.loadingAgencies = true

      this.$store
        .dispatch('agency/getAll', {
          queries: this.datatable.queries,
          page: 'index',
        })
        .then(() => {
          this.loadingAgencies = false
        })
        .catch(() => {
          this.loadingAgencies = false
        })
    },

    impersonate(userId) {
      this.loadingImpersonate = true

      this.$store
        .dispatch('auth/impersonate', userId)
        .then((res) => {
          this.$store
            .dispatch('auth/getProfile')
            .then((user) => {
              this.$router.push('/' + user.role.toLocaleLowerCase())
              this.loadingImpersonate = false
            })
            .catch(() => {
              this.loadingImpersonate = false
            })
        })
        .catch(() => {
          this.loadingImpersonate = false
        })
    },

    archive(agency) {
      this.showDeleteModal = true
      this.selectedAgency = agency
    },

    handleArchive() {
      this.showDeleteModal = false
      this.loadingRemove = this.selectedAgency.id
      this.$store
        .dispatch('agency/archive', this.selectedAgency.id)
        .then(() => {
          this.loadingRemove = null
          this.getAgencies()
        })
        .catch(() => {
          this.loadingRemove = null
        })
    },
  },
}
</script>
